// extracted by mini-css-extract-plugin
export default {"heading":"Or-z","createAccount":"Pr-z","disabled":"Qr-z","copy":"Rr-z","terms":"Sr-z"};